var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('p', { attrs: { "title": _vm.name } }, [_vm._v(_vm._s(_vm.name))]);
};
var staticRenderFns = [];

export { render, staticRenderFns };